module.exports = __webpack_public_path__ + "static/Key_Visual_original-57e59418d7c838aeeb2c96574202fdc9.jpg";